<template>
 <nav class="gh-footer-nav">
    <div class="container">
      <div class="gh-menu" justify="space-between">
        <ul class="gh-menu-list">
          <li v-for="item in menu"
            :key="item.label"
            class="gh-menu-item">
            <a :href="item.url" class="gh-menu-link">{{ item.label }}</a>
          </li>
        </ul>

        <div class="gh-copyright">
          <slot name="copyright"></slot>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'ghFooterMain',

    props: {
      menu: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style scoped lang="sass">
  .gh-footer-nav
    background: #010101
    transition: background 1s
    color: #fff
    > .container
      display: flex
      align-items: center
      justify-content: space-between

    .gh-menu
      display: flex
      justify-content: space-between
      width: 100%

    .gh-menu-list
      display: flex
      margin-right: 2rem
      margin-left: -16px
      padding: 0
      list-style: none

    .gh-menu-item
      + .gh-menu-item
        margin-left: 1rem

    .gh-menu-link
      color: #fff
      font-size: .8rem

    .gh-nav-button
      text-transform: inherit
      color: #fff

    .gh-copyright
      color: white
      font-size: .8rem
      align-items: center
      display: flex
      items-align: center
      .v-icon
        color: inherit
        font-size: 14px
      p
        margin-bottom: 0
    @media (max-width: 1023px)
      .gh-menu
        align-items: center
      .gh-menu-list
        margin-right: 0
        justify-content: center
        flex-wrap: wrap
        .gh-menu-item + .gh-menu-item
          margin-left: 0
      .gh-copyright
        text-align: center
    @media (max-width: 480px)
      padding: 1rem 0
</style>
